
export class Profile {
  constructor (params = {}) {
    this.id = params.id ? params.id : null
    this.sequence = params.sequence ? params.sequence : null
    this.type = params.type ? params.type : null
    this.documents = params.documents ? params.documents : []
    this.addresses = params.addresses ? params.addresses : []
    this.name = params.name ? params.name : null
    this.lastName = params.last_name ? params.last_name : null
    this.phoneNumber = params.phone_number ? params.phone_number : null
    this.email = params.email ? params.email : null
    this.dateOfBirth = params.date_of_birth ? params.date_of_birth : null
    this.gender = params.gender ? params.gender : null
    this.languageCode = params.language_code ? params.language_code : null
    this.dietRestrictions = params.diet_restrictions ? params.diet_restrictions : null
    this.attributes = params.attributes ? params.attributes : null
    this.editable = params.editable ? params.editable : null
    this.category = params.category ? params.category : null
    this.categoryId = params.category_id ? params.category_id : null
  }
}
